export default {
  open: false,
  title: null,
  content: null,
}
